<template>
    <div>
        <!-- <UnderConstruction/> -->
        <CollectionActionBar @saveClicked="onSaveClicked" @newClicked="onNewClicked" @printClicked="onPrintClicked"
            @nextClicked="onNextClicked" @prevClicked="onPrevClicked" @loadClicked="onLoadClicked" />
        <TabsWrapper :selected-tab="selectedTab" @headerClicked="tabHeaderClicked">
            <Tab title="Entry" icon="bi bi-clipboard-data">
                <div class="row">
                    <div class="form-group col-lg-5">
                        <label>Full Name</label>
                        <ComboboxView placeholder="Enter payor name" api-url="acctmaster/search"
                            @item-selected="onPayorSelected" @item-added="onItemAdded" :cancreateitem="true"
                            ref="cbActRef" />
                    </div>
                    <div class="form-group col-lg-3">
                        <label>Booklet #</label>
                        <ComboboxView ref="cbBooklet" :cancreateitem="false" @item-selected="onBookletSelected"
                            :api-url="`logbook/gen/search/0/${loadedTransaction.ctc.sysFK_InCharge_CTCEntries}`" />
                    </div>
                    <div class="form-group col-lg-2">
                        <label>CTC #</label>
                        <input v-model="loadedTransaction.ctc.userPK_CTCEntries"
                            class="form-control form-control-sm text-end" />
                    </div>
                    <div class="form-group col-lg-2">
                        <label>Date</label>
                        <input type="date" v-model="dateIssueFormatted" class="form-control form-control-sm text-end" />
                    </div>

                    <div v-if="shouldDisableInputs" class="warning-message text-danger">
                        {{ disableReason }}
                    </div>
                    <!-- Disable all inputs when conditions are met -->
                    <div class="row mt-3" :class="{ 'disabled-container': shouldDisableInputs }">
                        <div class="form-group col-lg-3">
                            <label>Last Name</label>
                            <input v-model="loadedTransaction.ctc.nameLast_CTCEntries" :disabled="shouldDisableInputs"
                                placeholder="Last Name" class="form-control form-control-sm">
                        </div>

                        <div class="form-group col-lg-4">
                            <label>First Name</label>
                            <input v-model="loadedTransaction.ctc.nameFirst_CTCEntries" :disabled="shouldDisableInputs"
                                placeholder="First Name" class="form-control form-control-sm">
                        </div>

                        <div class="form-group col-lg-3">
                            <label>Middle Name</label>
                            <input v-model="loadedTransaction.ctc.nameMiddle_CTCEntries" :disabled="shouldDisableInputs"
                                placeholder="Middle Name" class="form-control form-control-sm">
                        </div>
                        <div class="form-group col-lg-2">
                            <label>M.I.</label>
                            <input v-model="loadedTransaction.ctc.nameMI_CTCEntries" :disabled="shouldDisableInputs"
                                placeholder="Initials" class="form-control form-control-sm">
                        </div>

                        <div class="form-group col-lg-4">
                            <label>Address</label>
                            <SearchableCombobox @change="handleAddressChange" v-model="selectedAddress" ref="cbAddress"
                                :options="addresses" />
                        </div>
                        <div class="form-group col-lg-2">
                            <label>Gender</label>
                            <SearchableCombobox v-model="selectedGender"
                                :options="[{ label: 'MALE', value: 'MALE' }, { label: 'FEMALE', value: 'FEMALE' },]" />
                        </div>

                        <div class="form-group col-lg-3">
                            <label>TIN</label>
                            <input class="form-control form-control-sm"
                                v-model="loadedTransaction.ctc.tIN_CTCEntries" />
                        </div>


                        <div class="form-group col-lg-3">
                            <label>Mobile #</label>
                            <input class="form-control form-control-sm"
                                v-model="loadedTransaction.ctc.telNumShipping_UM" />
                        </div>
                        <div class="form-group col-lg-3">
                            <label>Citizenship</label>
                            <SearchableCombobox v-model="selectedCitizenship"
                                :options="[{ label: 'Filipino', value: 'Filipino' }]" />
                        </div>
                        <div class="form-group col-lg-2">
                            <label>ICR No.(If an allien)</label>
                            <input class="form-control form-control-sm"
                                v-model="loadedTransaction.ctc.iCRNo_CTCEntries" />
                        </div>
                        <div class="form-group col-lg-3">
                            <label>Place of birth</label>
                            <input class="form-control form-control-sm text-uppercase"
                                v-model="loadedTransaction.ctc.birthPlace_CTCEntries" />
                        </div>
                        <div class="form-group col-lg-2">
                            <label>Height cm.</label>
                            <input class="form-control form-control-sm text-end"
                                v-model="loadedTransaction.ctc.height_CTCEntries" />
                        </div>
                        <div class="form-group col-lg-2">
                            <label>Weight kg.</label>
                            <input class="form-control form-control-sm text-end"
                                v-model="loadedTransaction.ctc.weight_CTCEntries" />
                        </div>
                        <div class="form-group col-lg-3">
                            <label>Civil Status</label>
                            <SearchableCombobox v-model="selectedCivilStatus"
                                :options="[{ label: 'Single', value: 'Single' }, { label: 'Married', value: 'Married' }, { label: 'Widower', value: 'Widower' }]" />
                        </div>
                        <div class="form-group col-lg-2">
                            <label>Birth Date</label>
                            <input type="date" class="form-control form-control-sm text-end"
                                v-model="birthDateFormatted" />
                        </div>

                        <div class="form-group col-lg-1">
                            <label>Age</label>
                            <input class="form-control form-control-sm text-end" v-model="computedAge" />
                        </div>

                        <div class="form-group col-lg-6">
                            <label>Profession</label>
                            <input class="form-control form-control-sm text-end"
                                v-model="loadedTransaction.ctc.designation_CTCEntries" />
                        </div>

                        <div class="form-group col-lg-3">
                            <label>Bonded Cashier</label>
                            <select @change="checkChange" class="form-select form-select-sm"
                                v-model="loadedTransaction.transaction_Header.sysFK_InCharge_TransH">
                                <option :value="emp.value" v-for="emp in employeeOptions" :key="emp.value">{{ emp.label
                                    }}
                                </option>
                            </select>
                        </div>
                        <div class="col-lg-1 mt-3 pt-3">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" value="" id="defaultCheck1">
                                <label class="form-check-label" for="defaultCheck1">
                                    Corporate
                                </label>
                            </div>
                        </div>
                        <div class="col-lg-8 my-2 pb-2 card">
                            <div class="row">
                                <div class="col-lg-6"></div>
                                <div class="col-lg-6">
                                    <div class="d-flex justify-content-between">
                                        <span>Taxable Amount</span>
                                        <span>Amount Due</span>
                                    </div>
                                </div>
                            </div>
                            <div class="row  mt-2">
                                <span class="col-lg-6 text-sm">A. BASIC COMMUNITY TAX (P5.00) Voluntary or </span>
                                <div class="form-check col-lg-3">
                                    <input class="form-check-input" type="checkbox" v-model="loadedTransaction.ctc.exempted_CTCEntries" value="" id="chckExempt">
                                    <label class="form-check-label" for="chckExempt">
                                        Excempted (P1.00)
                                    </label>
                                </div>
                                <div class="col-lg-3">

                                    <input v-model="loadedTransaction.ctc.basicCommunityTax_CTCEntries" class="form-control form-control-sm text-end" />
                                </div>
                                <span class="col-lg-6 text-sm">
                                    B. ADDITIONAL COMMUNITY TAX (tax note exceeded P5,000.00
                                </span>
                                <div class="form-check col-lg-3">
                                    <input class="form-check-input" type="checkbox" value="" id="defaultCheck1">
                                    <label class="form-check-label" for="defaultCheck1">
                                        Override Amount
                                    </label>
                                </div>
                                <div class="col-lg-3 mt-1">
                                    <input class="form-control form-control-sm text-end" />
                                </div>
                                <span class="col-lg-6 text-sm">
                                    1. GROSS RECEIPTS OR EARNINGS DERIVED FROM BUSINESS DURING THE PRECEEDING YEAR(P1.00
                                    every P1,000.00)
                                </span>
                                <div class="col-lg-3 mt-1">
                                    <input v-model="loadedTransaction.ctc.taxableAmountB1_CTCEntries" class="form-control form-control-sm text-end" />
                                </div>
                                <div class="col-lg-3 mt-1">
                                    <input v-model="loadedTransaction.ctc.taxDueB1_CTCEntries" class="form-control form-control-sm text-end" />
                                </div>
                                <span class="col-lg-6 text-sm">
                                    2. SALARIES GROSS RECEIPT OR EARNINGS DERIVED FROM EXCERCISE OF PROFESSOR OR PURSUIT
                                    OF ANY OCCUPATION (P1.00 every P1,000.00)
                                </span>
                                <div class="col-lg-3 mt-1">
                                    <input v-model="loadedTransaction.ctc.taxableAmountB2_CTCEntries" class="form-control form-control-sm text-end" />
                                </div>
                                <div class="col-lg-3 mt-1">
                                    <input v-model="loadedTransaction.ctc.taxDueB2_CTCEntries" class="form-control form-control-sm text-end" />
                                </div>
                                <span class="col-lg-6 text-sm">
                                    3. INCOME FROM REAL PROPERTY (P1.00 every P1,000.00)
                                </span>
                                <div class="col-lg-3 mt-1">
                                    <input v-model="loadedTransaction.ctc.taxableAmountB3_CTCEntries" class="form-control form-control-sm text-end" />
                                </div>
                                <div class="col-lg-3 mt-1">
                                    <input v-model="loadedTransaction.ctc.taxDueB3_CTCEntries" class="form-control form-control-sm text-end" />
                                </div>

                            </div>
                            <div class="row">
                                <div class="col-lg-9">
                                </div>
                                <div class="col-lg-3">
                                    <div class="form-group">
                                        <label for="total">TOTAL</label>
                                        <input v-model="loadedTransaction.ctc.total_CTCEntries" id="total" class="form-control form-control-sm text-end" />
                                    </div>
                                </div>
                                <div class="col-lg-9">
                                </div>
                                <div class="col-lg-3">
                                    <div class="form-group">
                                        <label for="total">INTEREST</label>
                                        <input v-model="loadedTransaction.ctc.interest_CTCEntries" id="total" class="form-control form-control-sm text-end" />
                                    </div>
                                </div>
                                <div class="col-lg-9">
                                </div>
                                <div class="col-lg-3">
                                    <div class="form-group">
                                        <label for="total">TOTAL AMOUNT PAID</label>
                                        <input v-model="loadedTransaction.ctc.totalAmount_CTCEntries" id="total" class="form-control form-control-sm text-end" />
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

            </Tab>
            <Tab title="Index" icon="bi bi-table">
                <div>
                    <div class="text-end pe-0 pe-md-2">
                        <PaginatorComponent :items-per-page="pagination.itemsPerPage"
                            :current-page="pagination.currentPage" :total-items="pagination.totalItems"
                            @page-changed="handlePageChange" />
                    </div>
                    <form @submit.prevent="onLoadClicked">
                        <div class="table-responsive">
                            <table class="table table-sm table-hover align-middle" style="font-size: 0.875rem;">
                                <thead>
                                    <tr>
                                        <th>Book #</th>
                                        <th>Bonded Cashier</th>
                                        <th>OR #</th>
                                        <th>Status</th>
                                        <th>Issued</th>
                                        <th>Payor</th>
                                        <th>Account</th>
                                        <th>Pay Type</th>
                                        <th>Net Amount</th>
                                        <th>OR Type</th>
                                        <th>Prepared By</th>
                                        <th>Cash Amt.</th>
                                        <th>Others Amt.</th>
                                        <th>Cheque Amt.</th>
                                        <th>Cheque #</th>
                                        <th>Cheque Date</th>
                                        <th>Module Type</th>
                                        <th>Added On</th>
                                        <th>Added By</th>
                                    </tr>
                                    <tr>
                                        <th>
                                            <input class="form-control form-control-sm"
                                                v-model="searchModel.sysSeq_TransH" />
                                        </th>
                                        <th>
                                            <input class="form-control form-control-sm"
                                                v-model="searchModel.inChargedBy_TransH" />
                                            <button type="submit" class="btn btn-sm btn-secondary d-lg-none">
                                                <i class="bi bi-search"></i>
                                            </button>
                                        </th>
                                        <th>
                                            <input class="form-control form-control-sm"
                                                v-model="searchModel.userPK_TransH" />
                                        </th>
                                        <th>
                                            <input class="form-control form-control-sm"
                                                v-model="searchModel.status_TransH" />
                                        </th>
                                        <th>
                                            <input class="form-control form-control-sm"
                                                v-model="searchModel.dateIssue_TransH" />
                                        </th>
                                        <th>
                                            <input class="form-control form-control-sm"
                                                v-model="searchModel.nameFull_UM_TransH" />
                                        </th>
                                        <th>
                                            <input class="form-control form-control-sm"
                                                v-model="searchModel.nameFull_AcctMstr_TransH" />
                                        </th>
                                        <th>
                                            <input class="form-control form-control-sm"
                                                v-model="searchModel.payType_TransH" />
                                        </th>
                                        <th>
                                            <input class="form-control form-control-sm"
                                                v-model="searchModel.totalAmount_TransH" />
                                        </th>
                                        <th>
                                            <input class="form-control form-control-sm" readonly
                                                v-model="searchModel.type_TransH" />
                                        </th>
                                        <th>
                                            <input class="form-control form-control-sm"
                                                v-model="searchModel.preparedBy_TransH" />
                                        </th>
                                        <th>
                                            <input class="form-control form-control-sm"
                                                v-model="searchModel.amount01_TransH" />
                                        </th>
                                        <th>
                                            <input class="form-control form-control-sm"
                                                v-model="searchModel.amount03_TransH" />
                                        </th>
                                        <th>
                                            <input class="form-control form-control-sm"
                                                v-model="searchModel.amount02_TransH" />
                                        </th>
                                        <th>
                                            <input class="form-control form-control-sm"
                                                v-model="searchModel.accountDocumentNum_TransH" />
                                        </th>
                                        <th>
                                            <input class="form-control form-control-sm"
                                                v-model="searchModel.dateAccountDocument_TransH" />
                                        </th>
                                        <th>
                                            <input class="form-control form-control-sm"
                                                v-model="searchModel.moduleType_TransH" />
                                        </th>
                                        <th>
                                            <input class="form-control form-control-sm"
                                                v-model="searchModel.recordAddedDate_TransH" />
                                        </th>
                                        <th>
                                            <input class="form-control form-control-sm"
                                                v-model="searchModel.recordAddedBy_TransH" />
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="trans, index in transactions" :key="trans.sysPK_TransH"
                                        style="cursor: pointer;"
                                        :class="(trans?.userFK_Branch_TransH === 'EXCLUDERDCD' && hasRoles(['admin']) ? 'bg-danger' : '')"
                                        @click.prevent="transactionClicked(trans)">
                                        <td><i v-show="selectedIndex === index"
                                                class="bi bi-arrow-right-short text-info"></i> {{
                                                    trans?.sysSeq_TransH }}</td>
                                        <td>{{ trans?.inChargedBy_TransH }}</td>
                                        <td>{{ trans?.userPK_TransH }}</td>
                                        <td class="text-center">
                                            <span class="badge" :class="{
                                                'bg-warning': trans?.status_TransH === 'UNREMITTED',
                                                'bg-primary': trans?.status_TransH === 'REMITTED',
                                                'bg-success': trans?.status_TransH === 'RECEIVED'
                                            }">
                                                {{ trans?.status_TransH }}
                                            </span>
                                        </td>
                                        <td>{{ trans?.dateIssue_TransH }}</td>
                                        <td>{{ trans?.nameFull_UM_TransH?.toUpperCase() }}</td>
                                        <td>{{ trans?.nameFull_AcctMstr_TransH?.toUpperCase() }}</td>
                                        <td class="text-center">
                                            <span class="badge" :class="{
                                                'bg-warning': trans?.payType_TransH?.toLowerCase() === 'others',
                                                'bg-primary': trans?.payType_TransH?.toLowerCase() === 'cash',
                                                'bg-success': trans?.payType_TransH?.toLowerCase() === 'check'
                                            }">
                                                {{ trans?.payType_TransH }}
                                            </span>
                                        </td>
                                        <td class="text-end">{{ $formatters.formatCurrency(trans?.totalAmount_TransH) }}
                                        </td>
                                        <td>{{ trans?.type_TransH }}</td>
                                        <td>{{ trans?.preparedBy_TransH }}</td>
                                        <td class="text-end">{{ $formatters.formatCurrency(trans?.amount01_TransH) }}
                                        </td>
                                        <td class="text-end">{{ $formatters.formatCurrency(trans?.amount03_TransH) }}
                                        </td>
                                        <td class="text-end">{{ $formatters.formatCurrency(trans?.amount02_TransH) }}
                                        </td>
                                        <td>{{ trans?.accountDocumentNum_TransH }}</td>
                                        <td>{{ trans?.dateAccountDocument_TransH }}</td>
                                        <td>{{ trans?.moduleType_TransH }}</td>
                                        <td>{{ trans?.recordAddedDate_TransH }}</td>
                                        <td>{{ trans?.recordAddedBy_TransH }}</td>

                                    </tr>
                                </tbody>

                            </table>
                        </div>
                    </form>
                </div>
            </Tab>

        </TabsWrapper>
    </div>
</template>

<script setup>
import CollectionActionBar from '@/components/CollectionActionBar.vue'
import PaginatorComponent from '@/components/customs/PaginatorComponent.vue';
import Tab from '@/components/tabs/Tab.vue';
import ComboboxView from '@/components/customs/ComboboxView'
import spinnerService from "@/services/spinnerService";
import transactionService from "@/services/transactionService"
import TabsWrapper from '@/components/tabs/TabsWrapper.vue';
import SearchableCombobox from '@/components/customs/SearchableCombobox.vue'
import JSONbig from 'json-bigint'; // For handling big integers
import umService from '@/services/umService';
// eslint-disable-next-line
import { isInRange, getBookletNextNumber } from '@/utils/rangeHelper';
import { ref, computed, onMounted, watch } from "vue"
//import UnderConstruction from "@/components/customs/UnderConstruction"
// eslint-disable-next-line
const JSONbigString = JSONbig({
    useNativeBigInt: true,
    alwaysParseAsBig: false,
    protoAction: 'ignore',
    constructorAction: 'ignore'
});
const employeeOptions = ref();
const cbBooklet = ref();
const selectedBooklet = ref();
const selectedAddress = ref();
const selectedGender = ref();
const selectedCivilStatus = ref();
const selectedCitizenship = ref();
const selectedConcessionaire = ref();
const selectedIndex = ref(-1);
const cbActRef = ref(null);
const selectedTab = ref("Entry");
const loadedTransaction = ref({ ctc: { nameFull_CTC_Entries: null, sysFK_InCharge_CTCEntries: 0,taxableAmountB2_CTCEntries: 20000,basicCommunityTax_CTCEntries:5 }, transaction_Header: {} });
const transactions = ref([]);
const pagination = ref({ currentPage: 0, totalItems: 0, itemsPerPage: 50 })
const pageSearchModel = ref();
const searchModel = ref({ type_TransH: "CTCINDV" });
const addresses = ref();
const cbAddress = ref(null);


function  computeCommTax() {
    let interest = 0;
    let total = 0;
    let grandtotal = 0;
    loadedTransaction.value.ctc.taxDueB2_CTCEntries = Math.floor((loadedTransaction.value.ctc.taxableAmountB2_CTCEntries || 0)/1000)
    loadedTransaction.value.ctc.taxDueB1_CTCEntries = Math.floor((loadedTransaction.value.ctc.taxableAmountB1_CTCEntries || 0)/1000)
    loadedTransaction.value.ctc.taxDueB3_CTCEntries = Math.floor((loadedTransaction.value.ctc.taxableAmountB3_CTCEntries || 0)/1000)
    // Sum up tax entries
    if (loadedTransaction.value.ctc.taxDueB1_CTCEntries&& loadedTransaction.value.ctc.taxDueB1_CTCEntries > 0) {
      total += Number(loadedTransaction.value.ctc.taxDueB1_CTCEntries);
    }
    if (loadedTransaction.value.ctc.taxDueB2_CTCEntries && loadedTransaction.value.ctc.taxDueB2_CTCEntries > 0) {
      total += Number(loadedTransaction.value.ctc.taxDueB2_CTCEntries);
    }
    if (loadedTransaction.value.ctc.taxDueB3_CTCEntries && loadedTransaction.value.ctc.taxDueB3_CTCEntries > 0) {
      total += Number(loadedTransaction.value.ctc.taxDueB3_CTCEntries);
    }

    // Apply cancellation limits
    if (loadedTransaction.value.ctc.isCancelled_CTCEntries !== undefined) {
      if (loadedTransaction.value.ctc.isCancelled_CTCEntries === 1) {
        total = Math.min(total, 10000);
      } else {
        total = Math.min(total, 5000);
      }
    } else {
      total = Math.min(total, 5000);
    }

    // Add basic community tax
    total += Number(loadedTransaction.value.ctc.basicCommunityTax_CTCEntries);

  
    // Calculate interest based on month
   const issueDate = dateIssueFormatted.value 
  ? new Date(dateIssueFormatted.value) 
  : new Date(); // Fallback to current date
    const month = issueDate.getMonth() + 1; // JavaScript months are 0-11
    if (month > 1) {
      interest = Number((total * 0.02) * month);
    }

    grandtotal = Number(total) + Number(interest);
    loadedTransaction.value.ctc.total_CTCEntries = total;
    loadedTransaction.value.ctc.interest_CTCEntries = interest;
    loadedTransaction.value.ctc.totalAmount_CTCEntries = grandtotal;
  }

  watch(()=>loadedTransaction.value.ctc,(newValue)=>{
        newValue;
        computeCommTax();
  },{deep:true});

const dateIssueFormatted = computed({
    get() {
        if (!loadedTransaction.value.ctc.dateIssue_CTCEntries) {
            const today = new Date();
            return `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
        }
        return loadedTransaction.value.ctc.dateIssue_CTCEntries.split('T')[0];
    },
    set(newValue) {
        loadedTransaction.value.ctc.dateIssue_CTCEntries =
            newValue ? `${newValue}T00:00:00` : null;
    }
});

const birthDateFormatted = computed({
    get() {
        if (!loadedTransaction.value.ctc.birthDate_CTCEntries) {
            return null;
            //const today = new Date();
            //return `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
        }
        return loadedTransaction.value.ctc.birthDate_CTCEntries.split('T')[0];
    },
    set(newValue) {
        loadedTransaction.value.ctc.birthDate_CTCEntries =
            newValue ? `${newValue}T00:00:00` : null;
    }
});

const computedAge = computed(() => {
    if (!birthDateFormatted.value) return 0;

    try {
        const birthDate = new Date(birthDateFormatted.value);
        const today = new Date();

        // Calculate basic age difference
        let age = today.getFullYear() - birthDate.getFullYear();

        // Adjust if birthday hasn't occurred yet this year
        const monthDiff = today.getMonth() - birthDate.getMonth();
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }

        return age;
    } catch (e) {
        console.error("Error calculating age:", e);
        return 0;
    }
});

async function getBondedCashiers(forceRefresh = false) {

    try {
        const response = await umService.getBondedCashiers(forceRefresh);
        employeeOptions.value = Array.isArray(response)
            ? response.map(x => ({
                value: JSONbig.stringify(x.sysPK_UM).toString(),
                label: x.reportName_UM,
                raw: { ...x } // Clone the object to avoid reference issues
            }))
            : []; // Fallback if response isn't an array
        // return employeeOptions.value; // Optional: Return the transformed data
    } catch (error) {
        console.error("Failed to load bonded cashiers:", error);
        employeeOptions.value = [];
        throw error; // Re-throw if you want calling code to handle it
    }
}
//Other listeners
const handlePageChange = async (page) => {
    spinnerService.show();
    const response = await transactionService.search(page, pageSearchModel.value);
    pagination.value = { currentPage: page, totalItems: response.totalItems, itemsPerPage: response.itemsPerPage }
    transactions.value = response.data;

    spinnerService.hide();
}

const shouldDisableInputs = computed(() => {
    return !selectedConcessionaire.value || selectedConcessionaire.value?.sysPK_UM === 0
})

const transactionClicked = async (trans) => {
    spinnerService.show();
    selectedTab.value = "Entry";
    loadedTransaction.value = await transactionService.getCtcInfo(String(trans.sysPK_TransH));
    const address = { value: loadedTransaction.value.ctc.address_CTCEntries, label: loadedTransaction.value.ctc.address_CTCEntries };
    cbAddress.value?.addOption(address);
    cbAddress.value?.setSelected(address)
    cbBooklet.value.preSelectOption({
        label: loadedTransaction.value.booklet.text,
        value: loadedTransaction.value.booklet.value,
        raw: loadedTransaction.value.booklet
    });
    if (loadedTransaction.value.transaction_Header.nameFull_UM_TransH && loadedTransaction.value.transaction_Header.nameFull_UM_TransH !== '')
        cbActRef.value.preSelectOption({
            label: loadedTransaction.value.transaction_Header.nameFull_UM_TransH, value:
                loadedTransaction.value.transaction_Header.sysFK_UM_TransH,
            raw: {
                name_UM: loadedTransaction.value.transaction_Header.nameFull_UM_TransH, sysPK_UM:
                    loadedTransaction.value.transaction_Header.sysFK_UM_TransH,
                userPK_UM: loadedTransaction.value.transaction_Header.userFK_UM_TransH
            }
        });
    selectedCitizenship.value = { label: loadedTransaction.value.ctc?.citizenship_CTCEntries, value: loadedTransaction.value.ctc?.citizenship_CTCEntries }
    selectedGender.value = { label: loadedTransaction.value.ctc.gender_CTCEntries?.toUpperCase(), value: loadedTransaction.value.ctc.gender_CTCEntries?.toUpperCase() };
    selectedCivilStatus.value = { label: loadedTransaction.value.ctc.civilStat_CTCEntries, value: loadedTransaction.value.ctc.civilStat_CTCEntries?.toUpperCase() };
    //setTransaction();
    spinnerService.hide();
}

const tabHeaderClicked = (title) => {
    selectedTab.value = title;
}

const disableReason = computed(() => {
    if (!selectedConcessionaire.value) return "Please select payor name first."
    if (selectedConcessionaire.value?.sysPK_UM === 0) return "This concessionaire is not editable"
    return ""
})

function onBookletSelected(booklet) {
    selectedBooklet.value = booklet;
    if (booklet) {
        loadedTransaction.value.booklet = booklet.raw;
        loadedTransaction.value.transaction_Header.sysFK_BatchTransH_TransH = booklet.raw.sysPK_ARMLogBk;
        loadedTransaction.value.transaction_Header.sysSeq_TransH = booklet.raw.sysSeq_ARMLogBk;
        loadedTransaction.value.transaction_Header.userSeq_TransH = booklet.raw.userSeq_ARMLogBk;
            const bookletno = getBookletNextNumber(booklet.raw);
        if (loadedTransaction.value.transaction_Header.recMarker === "new") {
            loadedTransaction.value.transaction_Header.userPK_TransH = bookletno;
        }
        if(loadedTransaction.value.ctc.recMarker === "new"){
            loadedTransaction.value.ctc.userPK_CTCEntries = bookletno;
        }
    }
}

function onPayorSelected(item) {
    selectedConcessionaire.value = item?.raw;
}



function onItemAdded(item) {
    alert(JSON.stringify(item))
}

function handleAddressChange(item) {
    item
    //alert(JSON.stringify(item))
}


//End other listeners

//Start Action bar listeners
function onSaveClicked() {
    alert('saved');
}
function onNextClicked() {
    alert('next')
}
function onPrevClicked() {
    alert('prev')
}
function onNewClicked() {
    loadedTransaction.value = { ctc: { nameFull_CTC_Entries: null, sysFK_InCharge_CTCEntries: 0,taxableAmountB2_CTCEntries: 20000,basicCommunityTax_CTCEntries:5,recMarker: 'new' }, transaction_Header: {} };
    if(selectedBooklet.value)
    onBookletSelected(selectedBooklet.value);
    selectedAddress.value = {label: null, value: null}
    cbActRef.value?.preSelectOption({value: 0, label: null})
}
async function onLoadClicked() {
    spinnerService.show();
    pageSearchModel.value = { ...searchModel.value }
    selectedTab.value = "Index";
    const response = await transactionService.search(1, searchModel.value);
    pagination.value = { currentPage: 1, totalItems: response.totalItems, itemsPerPage: response.itemsPerPage }
    transactions.value = response.data;
    spinnerService.hide();
}
function onPrintClicked() {
    alert('print')
}

//End Action bar listeners

//System Events
onMounted(() => {
    getBondedCashiers();
    computeCommTax();
})

//End System Events
</script>